module.exports = new __parcel__URL__("zusam_logo.1eebfd28.svg").toString();